<template>
  <div class="tab_box">
    <div class="tab_item flex_start_center" v-for="(item, index) in listData" :key="index" @click="$emit('item-click', item)">
      <div class="time">
        <div class="day">
          {{ formatDay(item.createDate) }}
        </div>
        <div class="year" :style="{ width: yearWidth }">
          {{ formatYearMonth(item.createDate) }}
        </div>
      </div>
      <div class="con">
        <div class="word-more text_over_1">
          {{ item.title }}
        </div>
        <div class="intro">
          <div class="text_over_2">
            {{ item.secTitle }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newsList1',
  props: {
    // 列表数据
    listData: {
      type: Array,
      default: () => []
    },
    // 年份显示宽度
    yearWidth: {
      type: String,
      default: '70px'
    }
  },
  methods: {
    formatDay(dateString) {
      if (!dateString) return '';
      return dateString.split("T")[0].split("-")[2];
    },
    formatYearMonth(dateString) {
      if (!dateString) return '';
      const parts = dateString.split("T")[0].split("-");
      return `${parts[0]}-${parts[1]}`;
    }
  }
}
</script>

<style scoped lang="scss">
.tab_box {
  height: 300px;
  overflow-y: scroll;

  .tab_item {
    width: 100%;
    margin: 0 auto;
    height: 100px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }

    .time {
      width: 74px;
      height: 80px;
      border: 2px #93bf5d solid;
      background: #93bf5d;
      font-family: "Georgia";
      margin-right: 15px;
      text-align: center;
      padding-top: 10px;

      .year {
        background-color: #fff;
      }

      .day {
        height: 38px;
        font-size: 22px;
        color: #fff;
      }
    }

    .con {
      overflow: hidden;

      .intro {
        font-size: 14px;
        color: #888;
      }

      .word-more {
        font-size: 18px;
        text-decoration: none;
        color: #333;
        transition: all 0.5s ease;
        padding-bottom: 10px;
      }
    }
  }
}

/* 移动端样式 */
@media screen and (max-width: 768px) {
  .time {
    height: 60px!important;
    // .year {
    //   background-color: #fff;
    // }

    .day {
      height: 20px!important;
      font-size: 18px!important;
      margin-bottom: 6px;
    }
  }
}
</style>